import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {getFormattedDate} from "utils/dateutils";
import {capitalize} from "utils/formatters";
import en from "./locales/en/translation.json";

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "en",
    resources: {
      en
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
      useSuspense: true
    }
  })
  .then(() => {
    i18n.services.formatter.add("date", function toDate(value) {
      return value ? getFormattedDate(value) : "";
    });
    i18n.services.formatter.add("number", (value, lng, options) => {
      const formatter = new Intl.NumberFormat(lng, options);
      return formatter.format(value ?? 0);
    });
    i18n.services.formatter.add("capitalize", function toCapital(value = "") {
      return capitalize(value);
    });
    i18n.services.formatter.add("lowercase", function toLowerCase(value = "") {
      return value.toLowerCase();
    });
  });

export default i18n;
